import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import CashDeposit from "components/CashDeposit/CashDeposit";
import DaySheetClosure from "components/DaySheetClosure/DaySheetClosure";

import styles from "./LogCashFlow.module.scss";

const CASH_DEPOSIT = 0;
const DAY_SHEET_CLOSURE = 1;

// 1. Correct the parameter order in the handler
const handleTabChange = (event, newValue, setLogCashFlow) => {
  setLogCashFlow(newValue);
};

const LogCashFlow = () => {
  const [logCashFlow, setLogCashFlow] = useState(CASH_DEPOSIT);

  return (
    <div className={styles.mainContainer}>
      <Tabs
        className={styles.tabsHeader}
        value={logCashFlow}
        onChange={(event, newValue) =>
          handleTabChange(event, newValue, setLogCashFlow)
        }
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab
          className={styles.tabLabel}
          label="Cash Deposit"
          value={CASH_DEPOSIT}
        />
        <Tab
          className={styles.tabLabel}
          label="Day Sheet Closure"
          value={DAY_SHEET_CLOSURE}
        />
      </Tabs>
      {logCashFlow === CASH_DEPOSIT && <CashDeposit />}
      {logCashFlow === DAY_SHEET_CLOSURE && <DaySheetClosure />}
    </div>
  );
};

export default LogCashFlow;
